import "vidstack/player/styles/default/poster.css";
import "vidstack/player/styles/default/gestures.css";
import "vidstack/player/styles/default/captions.css";
import "vidstack/player/styles/default/controls.css";
import "vidstack/player/styles/default/buttons.css";
import "vidstack/player/styles/default/icons.css";
import "vidstack/player/styles/default/tooltips.css";
import "vidstack/player/styles/default/time.css";
import "vidstack/player/styles/default/sliders.css";
import {
defineCustomElement,
MediaPosterElement,
MediaGestureElement,
MediaCaptionsElement,
MediaControlsElement,
MediaControlsGroupElement,
MediaTooltipElement,
MediaTooltipTriggerElement,
MediaToggleButtonElement,
MediaTooltipContentElement,
MediaTimeSliderElement,
MediaSliderChaptersElement,
MediaSliderPreviewElement,
MediaSliderValueElement,
MediaPlayButtonElement
} from "vidstack/elements";

defineCustomElement(MediaPosterElement);
defineCustomElement(MediaGestureElement);
defineCustomElement(MediaCaptionsElement);
defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);
defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaToggleButtonElement);
defineCustomElement(MediaTooltipContentElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderChaptersElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaPlayButtonElement);